export default __webpack_public_path__ + "static/media/camila.276c438d.png";